import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss']
})
export class TermsConditionComponent implements OnInit {

  constructor() { }
  Company_Name = ""
  Platform_Name = ""
  Website_URL = ""
  App_Name = ""

  ngOnInit() {
    this.Company_Name = sessionStorage.getItem('ihjt45h45=CompanyName')
  }

}
